import React from "react";
import styled from "onnit-ui/lib/themes/styled";
import Box from "onnit-ui/lib/box/Box";
import BazaarVoiceStarRating from "../BazaarVoiceStarRating";
import Text from "onnit-ui/lib/text";
import useOnnitContext from "onnit-ui/lib/hooks/useOnnitContext";
import usePageData from "../../../hooks/usePageData";
import Breadcrumbs from "../Breadcrumbs";
import StickyHeader from "../StickyHeader";
import Product from "onnit-ui/lib/@types/interfaces/product/BuyBoxProduct";

interface Props {
    onProductChange?: (product: Product) => void;
    children: React.ReactElement;
    buyAreaChild?: React.ReactElement;
    stickyHeaderBtnText?: string;
    nameAsElement?: string;
}

const TopContainer = styled.div`
    box-sizing: border-box;
    max-width: 1920px;
    margin: 24px auto;
    @media (min-width: ${(p) => p.theme.breakpoints[2]}) {
        display: flex;
    }
`;

function DefaultProductPageTop({
    onProductChange,
    children,
    buyAreaChild,
    nameAsElement = "span"
}: Props) {
    const onnitContext = useOnnitContext();
    const {pageData} = usePageData();

    if (!pageData || !onnitContext) return null;

    return (
        <>
            <StickyHeader />
            <TopContainer>
                <Box flex="1 1 auto">{children}</Box>

                <Box p={[4, 4, 5]} flex="0 0 460px">
                    <Breadcrumbs breadcrumbs={pageData.breadcrumbs} mb={4} />

                    <Text
                        fontSize={8}
                        fontWeight="bold"
                        fontStyle="italic"
                        mb={2}
                        as={nameAsElement}
                        dangerouslySetInnerHTML={{ __html: pageData.name }}
                    />

                    <BazaarVoiceStarRating product={pageData.products[0]} />

                    <Text
                        my={6}
                        typeStyle="default"
                        color="grays.6"
                        dangerouslySetInnerHTML={{ __html: pageData.description }}
                    />

                    {buyAreaChild}
                </Box>
            </TopContainer>
        </>
    );
}

export default DefaultProductPageTop;
